import React from 'react';
import { withRouter } from 'react-router-dom';

import ErrorPage from './ErrorPage';

export const ErrorPageContainer = (props) => {
  const {
    backTo,
    message,
    backLabel,
    pageHeading,
  } = props;
  return (
    <ErrorPage
      backTo={backTo}
      message={message}
      backLabel={backLabel}
      pageHeading={pageHeading}
    />
  );
};

export default withRouter(ErrorPageContainer);



// WEBPACK FOOTER //
// ./src/components/ErrorPage/index.js